import React from 'react';
import toolActions from '../../redux/futures/tools/actions';
import _ from 'lodash';
import { connect } from 'react-redux';
import baseHelper from '../../helpers/BaseHelper';
import Input from '../../components/Input';

import * as types from '../../redux/futures/tools/types';




class RestoreLadiPage extends React.Component {
 
    constructor(props) {
        super(props);

        this.state = {
            ladiPage: { 

                email: "",

                ladipageID: ""
            },
            typing: false,
            typingTimeout: 0,
            loading: false,
            classNormal: "ladiui button primary",
            classLoading: "ladiui loader button primary",
            classApply: "ladiui button primary",
            mode: ''
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
        // this.defaultState = _.cloneDeep(this.state.ladiPage);
    }


    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            
             
            if (nextProps.action == types.RESTORE_LADIPAGE) {
                  
                if (nextProps.status) {
                    const _seft = this;
                    window.LadiUI.toastr('success', '', nextProps.message);
                    setTimeout(function () {
                        window.LadiUI.closeModal(_seft.ref.current);
                    },1000);
                    
                } else {
                    window.LadiUI.toastr('error', '', nextProps.message);
                }
            } 
        }
    }

    submit = () => {

        // Validate
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            // console.log(ref);
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }
        const { ladiPage } = this.state;
        const jsonData = {
            "email": ladiPage.email,
            "ladipage_id": ladiPage.ladipageID
        } 
        this.props.restore(jsonData);
        
        this.state.loading = true;
        this.state.classApply = this.state.classLoading;

    }
 
 
    onChangeInput = (event) => { 
         
        this.setState({
            ladiPage: {
                ...this.state.ladiPage,
                [event.target.name]: event.target.value
            }
        });
    } 
 

    resetForm = (event) => {
        if (!event.target.hasAttribute("data-dismiss")) {
            return;
        }

        this.setState({
            ladiPage: baseHelper.resetState(this.state.ladiPage),
        });
        window.LadiUI.closeModal(this.ref.current);

        // window.LadiUI.forEach(window.LadiUI.querySelector("#modal-store .ladiui input"), function (e) {
        //     e.classList.remove('error');
        // });
    }

    render() {
        const { ladiPage } = this.state;

         
        const title = 'Khôi phục Ladipage ';

        return (
            <div ref={this.ref} id="modal-restore-ladipage" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-restore-ladipage"
                onClick={this.resetForm}>
                <div className="ladiui-modal-content" >
                    <div className="ladiui-modal-header"><button type="button" className="ladiui-close-modal" data-dismiss="modal-restore-ladipage"><i className="ladi-icon icon-e-remove" data-dismiss="modal-restore-ladipage" /></button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body">
                        <form>
                            <div className="ladiui-tab-content">
                                <div className="ladiui-row">
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Email</label> 
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="email"
                                                validationName="Email"
                                                placeholder="Email"
                                                value={ladiPage.emailSend}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true, email: true }}
                                            /> 
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">ID Ladipage</label> 
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="idLadiPage"
                                                validationName="Email"
                                                placeholder="ID Ladipage"
                                                value={ladiPage.emailRecieve}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true, email: true }}
                                            /> 
                                        </div>
                                    </div>

                                </div> 
                                

                            </div>
                        </form>
                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-restore-ladipage">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-restore-ladipage" />Đóng
                        </button>
                        <button 
                        ref={this.ref}
                        className={this.state.classApply} 
                        onClick={this.submit}
                        disabled={this.state.loading}
                        >
                        <i className="ladi-icon icon-floppy-disk" style={{display:(this.state.loading)?'none':'', paddingRight:'5px'}}></i>  
                                   Khôi phục
                         </button>
                         
                    </div>
                </div>
            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        restore: (data) => dispatch(toolActions.restoreLadipage(data)) 
    }
}

const mapStateToProps = (state) => ({ ...state.tool });

export default connect(mapStateToProps, mapDispatchToProps)(RestoreLadiPage);